module.exports = __webpack_public_path__ + "static/teaser-mobile-5-5044a36071bdf94f95c5e1f313b9a316.png";